import { CASE_ENDPOINTS } from "@/Case/config";
import { HttpClient } from "@/App/services/HttpClient";
import { handleHttpRequest } from "@/Case/services/handleHttpRequest";

export default {
  loadCase(caseId: string): Promise<any> {
    return handleHttpRequest(HttpClient.get(CASE_ENDPOINTS.LOAD_CASE(caseId)));
  },
  startCase(payload: any, options: { placeholderId: string }): Promise<any> {
    return HttpClient.post(`${CASE_ENDPOINTS.START_CASE}?${options.placeholderId}`, payload);
  },
  modifyCase(caseId: string, payload: any): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.MODIFY_CASE(caseId), payload));
  },
  addTag(caseId: string, tagId: string): Promise<any> {
    return handleHttpRequest(HttpClient.post(CASE_ENDPOINTS.TAGS(caseId), null, { tagId }));
  },
  deleteTag(caseId: string, tagId: string): Promise<any> {
    return handleHttpRequest(HttpClient.delete(CASE_ENDPOINTS.TAGS(caseId), { tagId }));
  },
  addDataEnabledTag(caseId: string, tagId: string, fields: Array<object>): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.DATA_ENABLED_TAGS(caseId, tagId), fields));
  },
  getChatHistory(caseId: string): Promise<any> {
    return handleHttpRequest(HttpClient.get(CASE_ENDPOINTS.CHAT(caseId)));
  },
  sendChat(caseId: string, payload: any): Promise<any> {
    return handleHttpRequest(HttpClient.post(CASE_ENDPOINTS.CHAT(caseId), payload));
  },
  locationUpdate(caseId: string, payload: any): Promise<any> {
    return handleHttpRequest(HttpClient.post(CASE_ENDPOINTS.LOCATION_UPDATE(caseId), payload));
  },
  mediaUpdate(caseId: string, payload: any): Promise<any> {
    return handleHttpRequest(HttpClient.post(CASE_ENDPOINTS.MEDIA_UPDATE(caseId), payload));
  },
  getLiveConsultRoom(caseId: string): Promise<any> {
    return handleHttpRequest(HttpClient.get(CASE_ENDPOINTS.LIVE_CONSULT_ROOM(caseId)));
  },
  savePatientInfo(caseId: string, formId: string, payload: any): Promise<any> {
    return handleHttpRequest(HttpClient.put(CASE_ENDPOINTS.DYNAMIC_FORM(caseId, formId), payload));
  },
};
